var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1 ma-2",attrs:{"headers":_vm.headers,"items":_vm.reverseNetworks,"items-per-page":5},scopedSlots:_vm._u([{key:"item.timestamp",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(" "+_vm._s(new Date(item.timestamp).toLocaleString('en-GB', { timeZone: 'Europe/Helsinki' }))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }